module.exports = __webpack_public_path__ + "img/chr_ts_14.3355c2c2.png";